import React, { useContext } from 'react';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import { BiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { attemptSocialLogin as attemptSocialLoginAction } from '../redux/actions';
import { SocialLoginProvider } from '../types';
import useGoogleSignIn from '../hooks/useGoogleSignIn';
import StandardView from './StandardView';
import IconView from './IconView';

export interface Props {
  clientId: string;
  biData?: BiEvent;
  className?: string;
  redirectToJoin?: boolean;
  redirectToSisu?: boolean;
  view?: 'standard' | 'icon';
  attemptSocialLogin: typeof attemptSocialLoginAction;
  /** Lazyload the SDK */
  lazyload?: boolean;
}

const SocialButtonGoogle: React.FC<Props> = ({
  clientId,
  biData,
  className,
  view = 'standard',
  redirectToJoin = false,
  redirectToSisu,
  attemptSocialLogin,
  lazyload = false,
}) => {
  const isMobile = useContext(MobileContext);
  const { buttonRef, triggerLazyload } = useGoogleSignIn(clientId, lazyload, view, response =>
    attemptSocialLogin({
      provider: SocialLoginProvider.Google,
      token: response.credential,
      redirectToJoin,
      redirectToSisu,
    })
  );

  const triggerClickAfterTouch = view === 'icon' && isMobile;

  return (
    <BiDiv
      onMouseOver={lazyload ? () => triggerLazyload(!triggerClickAfterTouch) : undefined}
      onTouchStart={lazyload ? () => triggerLazyload(triggerClickAfterTouch) : undefined}
      biData={biData}
      className={className}
      aria-label="Google"
      innerRef={node => (buttonRef.current = node)}
    >
      {lazyload && (view === 'standard' ? <StandardView /> : <IconView />)}
    </BiDiv>
  );
};
SocialButtonGoogle.displayName = 'SocialButtonGoogle';

export default SocialButtonGoogle;
